export default __webpack_public_path__ + "static/aboutUsImage-084877ec05f4128025eb5d06b8e34531.png";